import { sha256 } from 'lib/utils/createHashUtils'
import {
  ASSISTANT_SURFACE_TARGET_TEXT_MAX_LENGTH,
  toAssistantSurfaceTargetText,
  sanitizeAssistantSurfacePlainText,
} from './assistantSurfacePlainText'

// TripPlannerSurfaceActivityEntry.displayText is required (never undefined), but
// toAssistantSurfaceTargetText can return undefined if sanitizing collapses the input to nothing.
// Every current builder composes displayText from non-empty literal text plus an interpolated
// part, so the literal text alone survives sanitization regardless of what's interpolated -- this
// can't happen in practice today, but the fallback keeps the return type honest and still bounded
// (a raw slice, skipping sanitization) rather than assuming it can never happen.
export function boundActivityDisplayText(displayText: string): string {
  return toAssistantSurfaceTargetText(displayText) ?? displayText.slice(0, ASSISTANT_SURFACE_TARGET_TEXT_MAX_LENGTH)
}

// Identity is part of the backend grouping key. Reserve it before shortening the
// description so equal names cannot merge and long names cannot truncate an ID.
// Oversized IDs use a stable digest here; the structured field remains the lookup ID.
export function formatEntityActivityDisplayText(description: string, identity: string | undefined): string {
  if (!identity) return boundActivityDisplayText(description)
  const suffix = identity.length <= 160 ? ` (id=${identity})` : ` (identity-sha256=${sha256(identity)})`
  const text = sanitizeAssistantSurfacePlainText(description) ?? ''
  return `${text.slice(0, Math.max(0, ASSISTANT_SURFACE_TARGET_TEXT_MAX_LENGTH - suffix.length))}${suffix}`
}
